// extracted by mini-css-extract-plugin
export default {"container":"eIH82ZRZOtDWS1Q8ikaY","logoContainer":"fH0xPDryGO5P2awHhIJn","logo":"A6uoUQP5HyrFDuoezkWc","buttons":"CygF1Ak1j2Kew6KZXyu_","furtherInfo":"XYkEgGHviXhkO5BWh8Vg"};